document.addEventListener("DOMContentLoaded", function(){

  function updatePrepaid(price){
    const el = document.getElementById("prepaid-price-value");
    if(!el) return;

    const prepaid = price * 0.9;

    el.innerHTML = (prepaid / 100).toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR'
    });
  }

  // 🔥 Listen to ALL clicks inside variant picker
  document.addEventListener("click", function(e){

    const picker = e.target.closest('[data-picker-type="button"]');
    if(!picker) return;

    setTimeout(() => {

      // 🔥 Minimog stores selected variant here
      const script = document.querySelector('script[data-selected-variant]');
      
      if(!script) return;

      try{
        const variant = JSON.parse(script.textContent);

        if(variant && variant.price){
          updatePrepaid(variant.price);
        }

      }catch(err){
        console.log("Variant parse error", err);
      }

    }, 200);

  });

});